<template>
  <section class="section Catalog">
    <div class="container">
      <div class="columns is-tablet">
        <div class="column is-hidden-mobile is-one-quarter-tablet">
          <AppSidebar />
        </div>
        <div class="column">
          <div class="columns is-multiline is-mobile">
            <div class="column is-half-mobile is-half-tablet is-one-third-desktop" v-for="product in listCatalog" :key="product.parent">
              <div class="ProductCard card" @click="showProduct(product)">
                <div class="ProductCard-image card-image">
                  <figure class="image">
                    <img :src="product.images.split(',')[0].replace('/upload/', '/upload/w_500,c_scale/')" >
                  </figure>
                </div>
                <div class="ProductCard-details">
                  <div class="content">
                    <h3 class="ProductCard-name">{{product.title}}</h3>
                  </div>
                </div>
                <div class="ProductCard-footer columns is-mobile">
                  <div class="ProductCard-footerBlock column is-narrow">#{{product.parent}}</div>
                  <div class="ProductCard-footerBlock column has-text-right truncate"><span>{{product.brand}}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductModal from '@/components/ProductModal'
import AppSidebar from '@/components/AppSidebar'
export default {
  name: 'Catalog',
  components: {
    AppSidebar
  },
  data() {
    return {
      brands: [],
      categories: {},
      bracup: {},
      colors: [],
      tagsBrand: [],
      tagsColors: [],
      tagsCategories: [],
      tagsBracup: []
    }
  },
  computed: {
    ...mapGetters([
      'getCatalog',
      'getTagsBrand',
      'getTagsColors',
      'getTagsCategories',
      'getTagsBracup',
      'getFilterBy'
    ]),
    listCatalog () {
      var instance = this
      var catalog = JSON.parse(JSON.stringify(instance.getCatalog))
      if (instance.getFilterBy.what) {
        catalog = catalog.filter(product => product[instance.getFilterBy.where].indexOf(instance.getFilterBy.what) !== -1)
      }
      if (instance.getTagsBrand.length || instance.getTagsColors.length || instance.getTagsCategories.length || instance.getTagsBracup.length) {
        if (instance.getTagsBrand.length) {
          catalog = catalog.filter(product => instance.getTagsBrand.some(tag => tag.brand === product.brand))
        }
        if (instance.getTagsColors.length) {
          console.log('instance.getTagsColors', instance.getTagsColors)
          catalog = catalog.filter(product => instance.getTagsColors.some(tag => product.colorGroup.some(group => tag.colorCode === group.colorCode)))
        }
        if (instance.getTagsCategories.length) {
          catalog = catalog.filter(product => instance.getTagsCategories.includes(product.categories))
        }
        if (instance.getTagsBracup.length) {
          catalog = catalog.filter(product => product.colors.filter(color => color.sizes.filter(size => instance.getTagsBracup.includes(size.cup.trim())).length).length)
        }
      }
      return catalog
    }
  },
  methods: {
    showProduct (product) {
      console.log(product);
      //Validar solo elementos unicos
      product.colors = [...new Map(product.colors.map(item => [item['colorCode'], item])).values()];
      this.$buefy.modal.open({
        parent: this,
        props: {
          product: product
        },
        hasModalCard: true,
        trapFocus: true,
        canCancel: false,
        component: ProductModal
      })
    },
    groupBy (array, key) {
      var priority = {
        'LEONISA': 0,
        'LEO': 1,
        'LUMAR': 2,
        'MUNDO JOVEN': 3,
        'INFANTIL INTERIOR': 4,
        'SHAPEWEAR INTERIOR': 5,
        'SHAPEWEAR EXTERIOR': 6,
        'PAQUETERIA LEONISA': 7
      }
      console.log(priority)
      return array.reduce((acc, x) => Object.assign({}, acc, { [x[key]]: (acc[x[key]] || []).concat(x) }), {})
    }
  }
}
</script>
<style lang="scss">
/deep/.darkClose .modal-close {
  background-color: rgba(0, 0, 0, 0.3);
  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
  }
}

.Catalog {
  padding: 1.5rem;
}

.ProductCard {
  border-radius: 7px;
  box-shadow: none;
  cursor: pointer;
  position: relative;
  width: 100%;
  transition: all 0.3s;
  &:hover {
    background: #f9f9f9;
  }
  &-image {
    border-radius: 7px 7px 0 0;
    overflow: hidden;
  }
  &-name {
    font-size: 1rem !important;
    font-weight: 300 !important;
    line-height: 1.5rem !important;
    @include from($tablet) {
      font-size: 1.5rem !important;
    }
  }
  &-details {
    padding: 10px;
  }
  &-detailsTitle {
    font-weight: 700;
    color: #393c45;
    font-size: 14px;
    display: block;
  }
  &-detailsContent {
    color: #969699;
    font-size: 14px;
    font-weight: 400;
    display: block;
    margin-bottom: 8px;
  }
  &-footer {
    border-top: 1px solid #f5f5f5;
    color: #9e9e9e;
    font-size: .7rem;
    position: absolute;
    right: 12px;
    bottom: 12px;
    left: 12px;
    width: 100%;
  }
  &-footerBlock {
    padding: 3px;
  }
}

.truncate {
  flex: 1;
  min-width: 0;
  span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.ProductCard .image {
  transform: scale(1);
  transition: all 0.3s;
}
.ProductCard:hover .image {
  transform: scale(1.1);
}

.ProductCard.card {
  border: 1px solid #f5f5f5;
  height: 100%;
  padding-bottom: 10px;
  position: relative;
  .card-footer {
    border-top: 1px solid #f5f5f5;
    color: #9e9e9e;
    font-size: .7rem;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}

.list-complete-item {
  transition: all 2s;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.p-1 {
  padding: 1em;
}
.sidebar-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  // min-height: 100vh;
  .sidebar-layout {
    display: flex;
    flex-direction: row;
    min-height: 100%;
    // min-height: 100vh;
  }
}
@media screen and (max-width: 1023px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini-mobile {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }
              ul {
                padding-left: 0;
                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .b-sidebar {
    .sidebar-content {
      &.is-mini {
        &:not(.is-mini-expand),
        &.is-mini-expand:not(:hover) {
          .menu-list {
            li {
              a {
                span:nth-child(2) {
                  display: none;
                }
              }
              ul {
                padding-left: 0;
                li {
                  a {
                    display: inline-block;
                  }
                }
              }
            }
          }
          .menu-label:not(:last-child) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

</style>